import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

import { TemplateAdministrationUpsert } from '../Models';

export const TemplateAPI = (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getTemplateList = (isTransfer: boolean) => {
		const serviceUrl = `/bookbuilding-api/Templates/GetAllTemplates`;
		return api.get(serviceUrl, { params: { isTransfer } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getAdministrationTemplatesData = () => {
		const serviceUrl = `/bookbuilding-api/Templates/GetAdministrationTemplatesData`;
		return api.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getAdministrationSharedTemplates = () => {
		const serviceUrl = `/bookbuilding-api/Templates/GetAdministrationSharedTemplates`;
		return api.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getAdministrationDFIsData = (idVehicle: number) => {
		const serviceUrl = `/bookbuilding-api/Templates/GetAdministrationDFIsData`;
		return api.get(serviceUrl, { params: { idVehicle } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getAdministrationTemplateDocuments = (templateId: number) => {
		const serviceUrl = `/bookbuilding-api/Templates/GetAdministrationTemplateDocuments`;
		return api.get(serviceUrl, { params: { templateId } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getTemplateFieldsPreview = (contractId: number) => {
		const serviceUrl = `/bookbuilding-api/Templates/GetTemplateFieldsPreview`;
		return api.get(serviceUrl, { params: { contractId } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveAdministrationTemplate = (data: TemplateAdministrationUpsert) => {
		const serviceUrl = `/bookbuilding-api/Templates/SaveAdministrationTemplate`;
		return api.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const deleteAdministrationTemplate = (id: number) => {
		const serviceUrl = `/bookbuilding-api/Templates/DeleteAdministrationTemplate`;
		return api.delete(serviceUrl, { params: { id } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const downloadAdministrationFile = (kind: string, name: string, languageId?: number) => {
		const serviceUrl = `/bookbuilding-api/Templates/DownloadAdministrationFile`;
		return api.get(serviceUrl, {
			params: { kind, name, languageId },
			responseType: 'blob'
		})
			.then((response: AxiosResponse) => {
				const explicitFileName = response.headers?.['x-download-filename'] || response.headers?.['X-Download-FileName'];
				const contentDisposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
				const fileNameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^\";]+)/i);
				const fileName = explicitFileName
					? decodeURIComponent(String(explicitFileName).trim())
					: fileNameMatch?.[1]
						? decodeURIComponent(fileNameMatch[1].replace(/"/g, '').trim())
						: undefined;

				return {
					blob: response.data,
					fileName
				};
			})
			.catch((error: any) => error);
	};

	const uploadAdministrationFile = (kind: string, name: string, file: File, languageId?: number) => {
		const formData = new FormData();
		formData.append('kind', kind);
		formData.append('name', name);
		if (languageId) {
			formData.append('languageId', languageId.toString());
		}
		formData.append('file', file);

		const serviceUrl = `/bookbuilding-api/Templates/UploadAdministrationFile`;
		return api.post(serviceUrl, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const importAdministrationFile = (
		kind: string,
		name: string,
		fileUrl: string,
		languageId?: number,
		idVehicle?: number,
		idShareType?: number
	) => {
		const serviceUrl = `/bookbuilding-api/Templates/ImportAdministrationFile`;
		return api.post(serviceUrl, {
			kind,
			name,
			languageId,
			idVehicle,
			idShareType,
			fileUrl
		})
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	return {
		getTemplateList,
		getAdministrationTemplatesData,
		getAdministrationSharedTemplates,
		getAdministrationDFIsData,
		getAdministrationTemplateDocuments,
		getTemplateFieldsPreview,
		saveAdministrationTemplate,
		deleteAdministrationTemplate,
		downloadAdministrationFile,
		uploadAdministrationFile,
		importAdministrationFile
	};
};
